// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface BackupBackup
 */
export interface BackupBackup {
  /**
   *
   * @type {number}
   * @memberof BackupBackup
   */
  exportTtl?: number;
  /**
   *
   * @type {string}
   * @memberof BackupBackup
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof BackupBackup
   */
  profile?: string;
  /**
   *
   * @type {string}
   * @memberof BackupBackup
   */
  status?: string;
  /**
   *
   * @type {string}
   * @memberof BackupBackup
   */
  timestamp?: string;
  /**
   *
   * @type {string}
   * @memberof BackupBackup
   */
  type?: string;
}

/**
 * Check if a given object implements the BackupBackup interface.
 */
export function instanceOfBackupBackup(value: object): value is BackupBackup {
  return true;
}

export function BackupBackupFromJSON(json: any): BackupBackup {
  return BackupBackupFromJSONTyped(json, false);
}

export function BackupBackupFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BackupBackup {
  if (json == null) {
    return json;
  }
  return {
    exportTtl: json['export_ttl'] == null ? undefined : json['export_ttl'],
    id: json['id'] == null ? undefined : json['id'],
    profile: json['profile'] == null ? undefined : json['profile'],
    status: json['status'] == null ? undefined : json['status'],
    timestamp: json['timestamp'] == null ? undefined : json['timestamp'],
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function BackupBackupToJSON(json: any): BackupBackup {
  return BackupBackupToJSONTyped(json, false);
}

export function BackupBackupToJSONTyped(
  value?: BackupBackup | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    export_ttl: value['exportTtl'],
    id: value['id'],
    profile: value['profile'],
    status: value['status'],
    timestamp: value['timestamp'],
    type: value['type'],
  };
}
